// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { CategoryCard } from 'components/shared/CategoryCard/CategoryCard'
import { Form } from 'components/shared/Form/Form'
import { getIsCompetencySelected } from 'components/shared/CompetenciesFormFields/helpers'

import { COMPETENCIES_FIELD } from './model'

import styles from './CompetenciesFormFields.module.scss'

export const CompetenciesFormFields = ({
  activeCategory,
  className = undefined,
  isCompetenciesDisabled = false,
  categories,
  control,
  formState,
  order,
  onClick,
}) => (
  <div className={cx(styles.fields, { [className]: Boolean(className) })}>
    {R.pipe(
      R.addIndex(R.reduceBy)(
        (acc, { description, label, name }, index) => [
          ...acc,
          { description, index, label, name },
        ],
        [],
        ({ category }) => category,
      ),
      R.toPairs,
      R.sort(
        ([current], [next]) =>
          R.indexOf(current, order) - R.indexOf(next, order),
      ),
      R.map(([category, competencies]) => (
        <CategoryCard key={category} {...{ activeCategory, category, onClick }}>
          {R.map(({ index, label, name }) => {
            const isSelected = getIsCompetencySelected(name, formState)

            return (
              <Form.Field
                error={formState.errors[name]?.message}
                field="checkbox"
                key={`${COMPETENCIES_FIELD}[${index}].${name}`}
                name={`${COMPETENCIES_FIELD}[${index}].${name}`}
                isDisabled={isCompetenciesDisabled && !isSelected}
                {...{ control, label }}
              />
            )
          }, competencies)}
        </CategoryCard>
      )),
    )(categories)}
  </div>
)
